function events(h) {
  function showTcc(id, cb) {
    let top = document.body.scrollTop || document.documentElement.scrollTop;
    id !== 'share' && (document.getElementById(id).style.marginTop = top + 'px');
    document.querySelector('.popups-cover').className += ' on';
    document.getElementById(id).className += ' on';
  }
  function closeTcc(id, cb) {
    if (document.querySelector('.popups').getElementsByClassName('on').length === 2) {
      document.querySelector('.popups-cover').className = document.querySelector('.popups-cover').className.replace(' on', '');
    }

    document.getElementById(id).className = document.getElementById(id).className.replace(' on', '');
  }
  return {
    showTcc,
    closeTcc
  }
}

export default events;
